import {Skeleton, TableCell, TableRow} from '@mui/material';

const TableSkeleton = ({rows = 5, colSpan = 5}) => (
  <>
    {[...Array(rows)].map((_, i) => (
      <TableRow key={i}>
        <TableCell colSpan={colSpan}>
          <Skeleton variant='rectangular' />
        </TableCell>
      </TableRow>
    ))}
  </>
);

export default TableSkeleton;
